import React, { useState, useContext, useEffect, useReducer } from 'react';
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Modal } from 'react-bootstrap';
import { AuthContext } from '../AuthContext';
import { useViewPort } from './Hooks/useViewPort';
import { getAPI } from './GdacsAPI';

const Login = () => {
    const authContext = useContext(AuthContext);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isResetModal, setIsResetModal] = React.useState(false);
    const [isModified, setIsModified] = React.useState(false);
    const [alert, setAlert] = useState(false);
    const { width } = useViewPort();
    const breakpoint = 520;
    const initDataObject = {
        username: "",
        password: ""
    }
    const history = useHistory();
    const [show, setShow] = React.useState(false);

    const handleClose = () => {
        setShow(false);
        setIsResetModal(undefined);
    }
    const handleShow = (e, user) => {
        if (user === "") {
            setResponseMessage("Please insert a valid username.");
            return;
        }
        else {
            setResponseMessage("");
            setShow(true);
        }
    }

    const checkValidation = Yup.object().shape({
        username: Yup.string().required("No Username provided."),
        password: Yup.string().required("No password provided.")//.min(8, "Password is too short - should be 8 chars minimum."),
    })
    const [data, setData] = React.useState(initDataObject);


    const handleSubmit = async e => {
        e.preventDefault();
    }

    async function GetUserToken(values) {
        let json = {
            username: values.username,
            password: values.password
        }
        const settings = {
            method: 'POST',
            type: 'no-cors',
            body: JSON.stringify(json),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/authenticate/`, settings)
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const dataUser = await response.json();

            if (dataUser.enabled === false && dataUser.status === "Deleted") {
                setResponseMessage(<>Your account has been deleted... if you want recover it, please contact <a href="/About/contactus.aspx" target="_blank" >us</a ></>);
                return;
            }

            if (dataUser.enabled === false && dataUser.status.startsWith("2")) {
                setResponseMessage("You need to activate your account, please check your e-mail and follow the instructions.");
                return;
            }

            if (dataUser.enabled === false && dataUser.status.startsWith("2")) {
                setResponseMessage("You need to activate your account, please check your e-mail and follow the instructions.");
                return;
            }



            authContext.login(dataUser);

            const settingsCredentials = {
                method: 'POST',
                type: 'no-cors',
                body: JSON.stringify(json),
                headers: {
                    'Authorization': 'Bearer ' + dataUser.token,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            };

            const responseCredentials = await fetch(getAPI() + `api/register/Users/getuserbycredential/`, settingsCredentials)
            if (!responseCredentials.ok) {
                const resp = await responseCredentials.json();
                setResponseMessage(resp.message);
                return;
            }
            else {
                const dataUserLog = await responseCredentials.json();
                setResponseMessage("You are logged.");
                setIsModified(false);
                if (dataUser.enabled === true && dataUser.status === "confirmed")
                    history.push("/Home", dataUserLog);
                if (dataUser.enabled === true && dataUser.status === "forgotpassword")
                    history.push("/ChangePwd", dataUserLog);
            }
        }

    }

    async function ResetPassword(e, user) {

        const settings = {
            method: 'POST',
        };

        const response = await fetch(getAPI() + `api/register/Users/forgotpassword?username=${user}`, settings)
        const resp = await response.json();
        if (!response.ok) {
            setResponseMessage(resp.message);
            setShow(false);
            setIsResetModal(undefined);
            return;
        }
        else {
            setIsModified(false);
            setIsResetModal(true);
        }
    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        GetUserToken(values);
    }

    return (

        <Formik
            initialValues={initDataObject}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div>
                    <form onSubmit={handleSubmit}>
                        <br />
                        <br />
                        <div className="login-wrapper">
                            <div className={(breakpoint > width ? "col-12 p_summary" : "col-8 p_summary")}>
                                For users registered after 2008, the username is an email address. Users registered before might have usernames that are different.
                            </div>

                            <div className={(breakpoint > width ? "col-12" : "col-5")}>
                                <br />
                                <label htmlFor="username">Username</label>
                                <input className="form-control form-control-sm"
                                    name="username"
                                    type="mail"
                                    placeholder="Enter your Username"
                                    value={values.username}
                                    onChange={handleChange}
                                />
                                <br />
                                {errors.email && touched.username && (
                                    <div className="input-feedback">{errors.username}</div>
                                )}
                                <label htmlFor="password">Password</label>
                                <input className="form-control form-control-sm"
                                    name="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={values.password}
                                    onChange={handleChange}
                                />
                                <br />
                                {errors.password && touched.password && (
                                    <div className="input-feedback">{errors.password}</div>
                                )}
                                {responseMessage &&
                                    <div className="input-feedback">{responseMessage}</div>
                                }
                                <br />
                                <button type="button " className="btn btn-primary btn-primary-login btn-sm" style={{ minWidth: "115px" }} onClick={handleSubmit}>
                                        Login
                        </button> &nbsp;
                                    <NavLink
                                        to={{
                                            pathname: 'Register',
                                            origin: "Login",
                                            navIndex: 0
                                        }}
                                    className="btn btn-primary btn-primary-login float-right btn-sm "   style={{ minWidth: "115px" }} >
                                        Register
                                    </NavLink> &nbsp;
                            <br />
                                <br />
                                <Button variant="info btn-sm" onClick={e => handleShow(e, values.username)}>
                                    Reset Password
                                    </Button>
                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Reset Password</Modal.Title>
                                    </Modal.Header>
                                    {isResetModal &&
                                        <><Modal.Body>Your Password has been reset, you'll receive a temporary Password at your email address.</Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="primary" onClick={handleClose}>
                                                    Ok
                                                    </Button>
                                            </Modal.Footer></>
                                    }
                                    {!isResetModal &&
                                        <><Modal.Body>Click on "Confirm" button to reset your password </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="primary" onClick={e => ResetPassword(e, values.username)}>
                                                Confirm
                                            </Button>
                                                <Button variant="secondary" onClick={handleClose}>
                                                    Cancel
                                            </Button>

                                            </Modal.Footer></>
                                    }
                                </Modal>
                                {alert && <h2> Submit Successful</h2>}
                                <br />
                            </div>
                            <div className={(breakpoint > width ? "col-12" : "col-8")}>
                                <br />
{/*                                 <div className="p_summary" style={{ fontSize: "16px", color: "red" }}>
                                    New user creation is temporarily suspended for maintenance.
                                </div> */}
                                <br />
                                <div className="p_summary" style={{ fontSize: "14px" }}>
                                    <div style={{ marginBottom: "10px" }}><b>Conditions for use:</b></div> 
                                    The data you provide in this form is kept for the purpose of alerting you <br /> and for internal usage statistics. The information will not be disclosed to third parties, unless it is necessary for the fulfillment of the purpose identified above.
                                    Your data is kept for 1 year after you unregister from the system.<br /> For further information on the European Commission Personal Data Protection, see <a href="http://ec.europa.eu/dpo-register/detail/DPR-EC-00240" target="_blank">DPR-EC-00240.1</a>.
                                    For further inquiries, contact <a href="/About/contactus.aspx" target="_blank">us</a>.
                                </div>

                        </div>
                        </div>
                        <br />
                        <br />
                    </form>
                </div>

            )}
        </Formik>
    );
}

export { Login };